(function ($) {
	$('.accordion-block .accordion__wrapper .accordion__title').on('click', function (e) {
		e.preventDefault();
		$(this).closest('.accordion__wrapper').toggleClass('active');
		$(this).closest('.accordion__wrapper').find('.accordion__content').slideToggle();
	});

	$('.accordion-block .expand-all a').on('click', function (e) {
	  e.preventDefault();
	  if($(this).hasClass('active')) {
		$(this).removeClass('active');
		$(this).html('Expand All');
		$(this).closest('.accordion-block').find('.accordion__wrapper').removeClass('active');
		$(this).closest('.accordion-block').find('.accordion__content').slideUp();
	  }
	  else{
		$(this).addClass('active');
		$(this).html('Collapse All');
		$(this).closest('.accordion-block').find('.accordion__wrapper').addClass('active');
		$(this).closest('.accordion-block').find('.accordion__content').slideDown();
	  }
	});
})(jQuery);
